import { createReducer } from '@reduxjs/toolkit';
import * as actions from './actions';
import { AppState } from '../../global/types';
import { EditPageState } from './types';

const initialState: EditPageState = {
  productsSearchForPharmacy: {
    data: null,
    loading: false,
    error: null,
  },

  setProduct: {
    selectedProduct: null,
  },

  productBySku: {
    error: null,
    loading: false,
    data: null,
  },

  postDataForMappings: {
    error: null,
    loading: false,
    data: null,
  },

  blockedProductByPharmacy: {
    error: null,
    loading: false,
    data: null,
  },

  blockedProductByNetwork: {
    error: null,
    loading: false,
    data: null,
  },

  unblockedProductByPharmacy: {
    error: null,
    loading: false,
    data: null,
  },

  unblockedProductByNetwork: {
    error: null,
    loading: false,
    data: null,
  },

  deleteMappings: {
    error: null,
    loading: false,
    data: null,
  },

  postProductsSearchInPharmacy: {
    error: null,
    loading: false,
    data: null,
  },
};

const reducer = createReducer(initialState, {
  [actions.getProductsSearchForPharmacy.REQUEST]: (state) => {
    state.productsSearchForPharmacy.loading = true;
  },
  [actions.getProductsSearchForPharmacy.ERROR]: (state, action) => {
    state.productsSearchForPharmacy.error = action.payload;
    state.productsSearchForPharmacy.loading = false;
  },
  [actions.getProductsSearchForPharmacy.SUCCESS]: (state, action) => {
    state.productsSearchForPharmacy.data = action.payload;
    state.productsSearchForPharmacy.loading = false;
  },
  [actions.getProductBySku.REQUEST]: (state) => {
    state.productBySku.loading = true;
  },
  [actions.getProductBySku.ERROR]: (state, action) => {
    state.productBySku.error = action.payload;
    state.productBySku.loading = false;
  },
  [actions.getProductBySku.SUCCESS]: (state, action) => {
    state.productBySku.data = action.payload;
    state.productBySku.loading = false;
  },
  [actions.setSelectedProduct.type]: (state, action) => {
    state.setProduct.selectedProduct = action.payload;
  },
  [actions.clearSelectedProduct.type]: (state) => {
    state.setProduct.selectedProduct = null;
  },
  [actions.postDataForMappings.REQUEST]: (state) => {
    state.postDataForMappings.loading = true;
  },
  [actions.postDataForMappings.ERROR]: (state, action) => {
    state.postDataForMappings.loading = false;
    state.postDataForMappings.error = action.payload.message;
  },
  [actions.postDataForMappings.SUCCESS]: (state, action) => {
    state.postDataForMappings.data = action.payload;
    state.postDataForMappings.loading = false;
  },
  [actions.blockedProductByPharmacy.REQUEST]: (state) => {
    state.blockedProductByPharmacy.loading = true;
  },
  [actions.blockedProductByPharmacy.SUCCESS]: (state, action) => {
    state.blockedProductByPharmacy.loading = false;
    state.blockedProductByPharmacy.data = action.payload.status;
  },
  [actions.blockedProductByPharmacy.ERROR]: (state, action) => {
    state.blockedProductByPharmacy.loading = false;
    state.blockedProductByPharmacy.error = action.payload;
  },
  [actions.blockedProductByNetwork.REQUEST]: (state) => {
    state.blockedProductByNetwork.loading = true;
  },
  [actions.blockedProductByNetwork.SUCCESS]: (state, action) => {
    state.blockedProductByNetwork.loading = false;
    state.blockedProductByNetwork.data = action.payload.status;
  },
  [actions.blockedProductByNetwork.ERROR]: (state, action) => {
    state.blockedProductByNetwork.loading = false;
    state.blockedProductByNetwork.error = action.payload;
  },
  [actions.unblockedProductByPharmacy.REQUEST]: (state) => {
    state.unblockedProductByPharmacy.loading = true;
  },
  [actions.unblockedProductByPharmacy.SUCCESS]: (state, action) => {
    state.unblockedProductByPharmacy.loading = false;
    state.unblockedProductByPharmacy.data = action.payload.status;
  },
  [actions.unblockedProductByPharmacy.ERROR]: (state, action) => {
    state.unblockedProductByPharmacy.loading = false;
    state.unblockedProductByPharmacy.error = action.payload;
  },
  [actions.unblockedProductByNetwork.REQUEST]: (state) => {
    state.unblockedProductByNetwork.loading = true;
  },
  [actions.unblockedProductByNetwork.SUCCESS]: (state, action) => {
    state.unblockedProductByNetwork.loading = false;
    state.unblockedProductByNetwork.data = action.payload.status;
  },
  [actions.unblockedProductByNetwork.ERROR]: (state, action) => {
    state.unblockedProductByNetwork.loading = false;
    state.unblockedProductByNetwork.error = action.payload;
  },
  [actions.deleteMappings.REQUEST]: (state) => {
    state.deleteMappings.loading = true;
  },
  [actions.deleteMappings.SUCCESS]: (state, action) => {
    state.deleteMappings.loading = false;
    state.deleteMappings.data = action.payload.status;
  },
  [actions.deleteMappings.ERROR]: (state, action) => {
    state.deleteMappings.loading = false;
    state.deleteMappings.error = action.payload;
  },
  [actions.postProductsSearchInPharmacySaga.REQUEST]: (state) => {
    state.postProductsSearchInPharmacy.loading = true;
  },
  [actions.postProductsSearchInPharmacySaga.ERROR]: (state, action) => {
    state.postProductsSearchInPharmacy.loading = false;
    state.postProductsSearchInPharmacy.error = action.payload;
  },
  [actions.postProductsSearchInPharmacySaga.SUCCESS]: (state, action) => {
    state.postProductsSearchInPharmacy.data = action.payload;
    state.postProductsSearchInPharmacy.loading = false;
  },
});

const productsSearchLoading = (state: AppState) =>
  state.editPageReducer.productsSearchForPharmacy.loading;
const productsSearchError = (state: AppState) =>
  state.editPageReducer.productsSearchForPharmacy.error;
const productsSearchData = (state: AppState) =>
  state.editPageReducer.productsSearchForPharmacy.data;
const setSelectedProduct = (state: AppState) =>
  state.editPageReducer.setProduct.selectedProduct;

const postDataForMapError = (state: AppState) =>
  state.editPageReducer.postDataForMappings.error;

const productBySkuData = (state: AppState) =>
  state.editPageReducer.productBySku.data;
const productBySkuError = (state: AppState) =>
  state.editPageReducer.productBySku.error;
const productBySkuLoading = (state: AppState) =>
  state.editPageReducer.productBySku.loading;

const postProductsSearchInPharmacyData = (state: AppState) =>
  state.editPageReducer.postProductsSearchInPharmacy.data;
const postProductsSearchInPharmacyError = (state: AppState) =>
  state.editPageReducer.postProductsSearchInPharmacy.error;
const postProductsSearchInPharmacyLoading = (state: AppState) =>
  state.editPageReducer.postProductsSearchInPharmacy.loading;

const selectors = {
  productsSearchLoading,
  productsSearchData,
  productsSearchError,
  setSelectedProduct,
  productBySkuData,
  productBySkuError,
  productBySkuLoading,
  postDataForMapError,
  postProductsSearchInPharmacyData,
  postProductsSearchInPharmacyError,
  postProductsSearchInPharmacyLoading,
};

export { selectors };
export default reducer;
